import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from 'next-themes'

import { App } from './App'
import { ApiRequestError } from '@/lib/api'
import './index.css'

function onApiError(error: unknown): void {
  if (error instanceof ApiRequestError && error.isLocked) {
    void queryClient.invalidateQueries({ queryKey: ['vault-status'] })
  }
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: onApiError }),
  mutationCache: new MutationCache({ onError: onApiError }),
  defaultOptions: {
    queries: {
      // Server state is polled explicitly per view; a stale-while-revalidate window of a few
      // seconds keeps tab switches from hammering the backend.
      staleTime: 5_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
})

const container = document.getElementById('root')
if (!container) {
  throw new Error('Das Wurzelelement #root fehlt in index.html.')
}

createRoot(container).render(
  <StrictMode>
    {/* storageKey has to match the inline script in index.html that avoids the light flash. */}
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      storageKey="kontor-theme"
      disableTransitionOnChange
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
)
